/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} External_Apis_Field_Additional_HostsInputs */



/**
* | output |
* | --- |
* | "Additional hosts" |
*
* @param {External_Apis_Field_Additional_HostsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const external_apis_field_additional_hosts = /** @type {((inputs?: External_Apis_Field_Additional_HostsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<External_Apis_Field_Additional_HostsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Weitere Hosts")
	return /** @type {LocalizedString} */ ("Additional hosts")
});